import PropTypes from 'prop-types';
import { Box, List, ListItemButton, ListItemText, Typography } from "@mui/material";

export default function ConversationSidebar({ conversations, selectedId, loading, error, busy, onSelect }) {
  return (
    <Box sx={{ width: 240, flexShrink: 0 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>Previous conversations</Typography>
      {loading && !conversations.length
        ? <Typography variant="body2" color="text.secondary">Loading…</Typography>
        : error
          ? <Typography variant="body2" color="error">Couldn't load conversations</Typography>
          : !conversations.length
          ? <Typography variant="body2" color="text.secondary">None yet</Typography>
          : (
            <List dense disablePadding>
              {conversations.map((c) => (
                <ListItemButton
                  key={c.conversationId}
                  disabled={busy}
                  selected={c.conversationId === selectedId}
                  onClick={() => onSelect(c.conversationId)}
                >
                  <ListItemText
                    primary={c.title || 'Untitled'}
                    secondary={c.updatedAtUtc ? new Date(c.updatedAtUtc).toLocaleDateString() : null}
                    primaryTypographyProps={{ noWrap: true }}
                  />
                </ListItemButton>
              ))}
            </List>
          )}
    </Box>
  );
}

ConversationSidebar.propTypes = {
  conversations: PropTypes.arrayOf(PropTypes.shape({
    conversationId: PropTypes.string,
    title: PropTypes.string,
    updatedAtUtc: PropTypes.string,
  })),
  selectedId: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  busy: PropTypes.bool,
  onSelect: PropTypes.func,
};
